import React, { useEffect } from 'react';
// import './style.css';
import Routes from './routes/index';
import { Interceptors } from './services/middlewares/Interceptors';

const App = () => {
  Interceptors()

  return (
    <div className="App">
      <Routes />
    </div>
  );
}
export default App;